import { Box, Grid, Typography } from "@material-ui/core";
import { HighlightOffTwoTone } from "@material-ui/icons";
import React from "react";
interface propsType {}
export default function ErrorOccured() {
    return (
        <div className="introPhaseContainer">
            <Grid
                style={{ height: "100%", margin: "auto" }}
                lg={4}
                sm={12}
                container
                direction="column"
                alignItems="stretch"
            >
                <Grid
                    item
                    className="transparentBackground"
                    container
                    style={{ flex: 1, backgroundColor: "#85C441AA", padding: "24px 24px" }}
                >
                    <Box p={4} borderRadius={20} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                        <Typography variant="h5">An error has occurred.</Typography>
                        <Box mb={3} mt={3}>
                            <Typography variant="body1" align="center">
                                Please contact your system administrator.
                            </Typography>
                        </Box>
                        <Box fontSize={150} color="red" textAlign="center" style={{ lineHeight: 0.8 }}>
                            <HighlightOffTwoTone fontSize="inherit" />
                        </Box>

                        <Box textAlign="center">
                            Powered By <br />
                            <img
                                src="/images/GuideStream360Logo-dark.png"
                                alt="Powered by Guide Stream 360"
                                style={{
                                    objectFit: "scale-down",
                                    marginTop: 5,
                                    marginBottom: 0,  
                                    maxWidth: "85%",
                                    // filter: "drop-shadow(rgba(0, 0, 0, 0.5) 3px 2px 11px)",
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}
